module.exports = {"id":"dp4_4l1q1","text":"Environmental Impacts of Digital Technologies","instructions":"Individual users can influence the environmental impact of digital technologies through everyday choices.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.4","questionType":"PickOne","random":false,"options":[{"id":"dp4_4l1q1-a1","text":"True","score":1.8},{"id":"dp4_4l1q1-a2","text":"Not sure","score":0},{"id":"dp4_4l1q1-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.4/l1q1.json
// module id = 1267
// module chunks = 41